export default __webpack_public_path__ + "static/media/img-0317-madagascar-full-face.9ce111e8.png";